import { useEffect } from 'react';
import { useLocation } from 'react-router';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top for certain routes or conditions
    if (!location.hash) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // Optional: smooth scrolling
      });
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export default ScrollToTop;